import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar__content" }
const _hoisted_3 = { class: "sidebar__content-item sidebar__content-item--languages" }
const _hoisted_4 = { class: "sidebar__languages-label" }
const _hoisted_5 = { class: "sidebar__languages-flags" }
const _hoisted_6 = ["src", "alt", "onClick", "onKeydown"]
const _hoisted_7 = { class: "sidebar__content-item" }
const _hoisted_8 = { class: "sidebar__content-item" }
const _hoisted_9 = { class: "sidebar__content-item" }
const _hoisted_10 = { class: "sidebar__content-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!

  return (_openBlock(), _createBlock(_component_OnClickOutside, {
    onTrigger: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close-sidebar')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('Translation Language')), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translationLanguages, (code) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: code,
                  src: _ctx.imageURL(_ctx.flags[code]),
                  alt: _ctx.languages[code],
                  class: _normalizeClass(["sidebar__languages-flag", { 'sidebar__languages-flag--active': code === _ctx.translationLanguage }]),
                  onClick: ($event: any) => (_ctx.selectTranslationLanguage(code)),
                  onKeydown: ($event: any) => (_ctx.selectTranslationLanguage(code))
                }, null, 42, _hoisted_6))
              }), 128))
            ])
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-item",
              to: "/lists",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-sidebar')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Lists')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-item",
              to: "/games",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-sidebar')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Games')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-item",
              to: "/settings",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-sidebar')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Settings')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-item",
              to: "/support",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close-sidebar')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Support')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}